'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var LicenseStatus = /*#__PURE__*/function (LicenseStatus) {
  LicenseStatus["Valid"] = "Valid";
  LicenseStatus["Invalid"] = "Invalid";
  LicenseStatus["Expired"] = "Expired";
  LicenseStatus["NoLicense"] = "No License";
  return LicenseStatus;
}({});

/**
 * TigerGraph license information.
 *
 * @export
 * @interface License
 */

exports.LicenseStatus = LicenseStatus;
